function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { rgba } from "polished";
export default (function (theme) {
  function addStates(css, _ref) {
    var hover = _ref.hover,
      active = _ref.active,
      __internal__hover = _ref.__internal__hover,
      __internal__active = _ref.__internal__active;
    return _objectSpread(_objectSpread(_objectSpread({}, css), {}, {
      ":hover": hover
    }, __internal__hover && hover), {}, {
      ":active": active
    }, __internal__active && active);
  }
  function getButtonCSS(css) {
    return _objectSpread(_objectSpread({}, css), {}, {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      boxSizing: "border-box",
      width: "100%"
    });
  }
  return {
    getCSS: function getCSS(_ref2) {
      var targetElement = _ref2.targetElement,
        appearance = _ref2.appearance,
        variant = _ref2.variant,
        buttonTheme = _ref2.buttonTheme,
        __internal__keyboardFocus = _ref2.__internal__keyboardFocus,
        __internal__hover = _ref2.__internal__hover,
        __internal__active = _ref2.__internal__active;
      switch (targetElement) {
        case "anchor":
          {
            return _objectSpread(_objectSpread({
              textDecoration: "none",
              borderRadius: theme.radii[1],
              outline: 0,
              display: ["primary-button", "secondary-button", "icon"].includes(appearance) ? "inline-flex" : null,
              verticalAlign: appearance === "icon" ? "top" : null
            }, theme.focusStyles.focusVisible), __internal__keyboardFocus && theme.focusStyles.__keyboardFocus);
          }
        case "span":
          {
            switch (variant) {
              case "light-bg":
                {
                  return addStates({
                    fontFamily: theme.fonts.body,
                    fontWeight: theme.fontWeights.light,
                    borderBottomWidth: theme.borderWidths[0],
                    borderBottomStyle: "solid",
                    transition: theme.transitions.link,
                    color: theme.colors.primary.blue.t100,
                    borderBottomColor: rgba(theme.colors.primary.blue.t100, 0.5)
                  }, {
                    hover: {
                      borderBottomColor: theme.colors.primary.blue.t100,
                      backgroundColor: theme.colors.secondary.lightBlue.t25
                    },
                    active: {
                      borderBottomColor: theme.colors.primary.blue.t100,
                      backgroundColor: theme.colors.secondary.lightBlue.t25
                    },
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                }
              case "medium-bg":
                {
                  return addStates({
                    fontFamily: theme.fonts.body,
                    fontWeight: theme.fontWeights.light,
                    borderBottomWidth: theme.borderWidths[0],
                    borderBottomStyle: "solid",
                    transition: theme.transitions.link,
                    color: theme.colors.primary.blue.t100,
                    borderBottomColor: rgba(theme.colors.primary.blue.t100, 0.5)
                  }, {
                    hover: {
                      borderBottomColor: theme.colors.primary.blue.t100,
                      backgroundColor: theme.colors.white
                    },
                    active: {
                      borderBottomColor: theme.colors.primary.blue.t100,
                      backgroundColor: theme.colors.white
                    },
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                }
              case "dark-bg":
                {
                  return addStates({
                    fontFamily: theme.fonts.body,
                    fontWeight: theme.fontWeights.light,
                    borderBottomWidth: theme.borderWidths[0],
                    borderBottomStyle: "solid",
                    transition: theme.transitions.link,
                    color: theme.colors.white,
                    borderBottomColor: rgba(theme.colors.white, 0.5)
                  }, {
                    hover: {
                      borderBottomColor: theme.colors.secondary.lightBlue.t25,
                      backgroundColor: rgba(theme.colors.black, 0.45)
                    },
                    active: {
                      borderBottomColor: theme.colors.secondary.lightBlue.t25,
                      backgroundColor: rgba(theme.colors.black, 0.45)
                    },
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                }
              case "blue-button":
                {
                  return getButtonCSS(buttonTheme.getCSS({
                    targetElement: "button",
                    variant: appearance === "primary-button" ? "primary" : "secondary",
                    color: "highlight.blue.t100",
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  }));
                }
              case "white-button":
                {
                  return getButtonCSS(buttonTheme.getCSS({
                    targetElement: "button",
                    variant: appearance === "primary-button" ? "primary" : "secondary",
                    color: "white",
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  }));
                }
              case "black-button":
                {
                  return getButtonCSS(buttonTheme.getCSS({
                    targetElement: "button",
                    variant: "secondary",
                    color: "black",
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  }));
                }
              case "green-button":
                {
                  return getButtonCSS(buttonTheme.getCSS({
                    targetElement: "button",
                    variant: "primary",
                    color: "green",
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  }));
                }
              default:
                {
                  break;
                }
            }
            return {};
          }
        default:
          {
            return {};
          }
      }
    }
  };
});